import { useMemo } from 'react'

import { toSegments } from '../lib/segments'
import { splitThinking } from '../lib/think'
import { Markdown } from './Markdown'
import { ThinkBlock } from './ThinkBlock'
import { ToolCard } from './ToolCard'

/**
 * Bir asistan mesajinin govdesi: dusunme + segmentler.
 *
 * Sira onemli: ONCE `<think>` ayristirilıyor, SONRA toolcard sentinel'leri.
 * Tersi olsa `<think>` icinde gecen bir sentinel benzeri metin kart olarak
 * yorumlanirdi.
 *
 * Bu bilesen mesajin CANLI mi GECMISTEN mi geldigini bilmiyor - tek fark
 * `streaming` bayragi (caret ve acik dusunme kutusu). Yani gecmis ve canli
 * render'i TEK kod yolu; ikisinin farkli gorunmesi klasik bir regresyon
 * kaynagi ve boylece yapisal olarak imkansiz.
 */
export function MessageBody({ text, streaming }: { text: string; streaming: boolean }) {
  const think = useMemo(() => splitThinking(text), [text])
  const segments = useMemo(() => toSegments(think.answer), [think.answer])

  return (
    <>
      <ThinkBlock text={think.thinking ?? ""} streaming={think.streamingThought} />
      {segments.map((segment, index) => {
        const isLast = index === segments.length - 1
        // Imlec YALNIZCA gercekten akan son segmentte: dusunme bloguysa
        // (`think.streamingThought`) imlec ORADA gosteriliyor, burada degil.
        const isCaretHere = streaming && isLast && !think.streamingThought
        return segment.kind === 'md' ? (
          // Index anahtar olarak GUVENLI: segmentler her render'da ayni
          // metinden yeniden turetiliyor, yani liste yeniden siralanmiyor
          // veya araya ekleme yapilmiyor - yalnizca sonuna ekleniyor.
          <Markdown key={index} text={segment.text} streaming={isCaretHere} />
        ) : (
          <ToolCard key={index} data={segment.data} />
        )
      })}
    </>
  )
}
